import Vue from 'vue'
import Cognito from './cognito'
import config from './../config/cognito.js'

Vue.use(Cognito, config)

export default new Cognito()
